import { Colors } from 'src/components/theme'

import styled from '@emotion/styled'
import { TelescopeIcon } from 'src/components/icons/telescope'
import { Typography } from '@mui/material'

const EmptyContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const GraphEmpty = () => {
  return (
    <EmptyContainer>
      <TelescopeIcon size={48} color="rgba(133, 153, 174, 1)" />
      <Typography variant="textmdm" color={Colors.neutral400} align="center">
        No data to show
      </Typography>
    </EmptyContainer>
  )
}
